import { InjectionToken } from '@angular/core';

import type { ClarityControlCenterTabBadge } from './clarity-control-center-tab-badge.model';

/**
 * Every badge offered to the Clarity Control Center tab strip, registered `multi: true`.
 *
 * This is the seam that keeps the shell independent of the features it draws counts for. A feature
 * that wants a number beside its tab contributes exactly one `ClarityControlCenterTabBadge` with
 * `{ provide: CLARITY_CONTROL_CENTER_TAB_BADGES_TOKEN, useFactory: …, multi: true }`; the shell
 * injects the whole array and matches each entry's `tabId` against the tab it is drawing. The
 * inversion is the point — the shell depends on this `type:util` library and on nothing else, so a
 * feature can add or drop a badge without the shell changing and without the shell's library ever
 * being allowed to depend on the feature's. A `type:util` library may depend on no other tag at
 * all, which is exactly what makes it safe for every feature to reach for.
 *
 * The token declares no factory, so it has no default value: an injection site where no feature has
 * contributed throws unless it asks for the array optionally. Read it as
 * `inject(CLARITY_CONTROL_CENTER_TAB_BADGES_TOKEN, { optional: true }) ?? []` — with `optional` the
 * unprovided case is `null`, and the `?? []` is what turns "nobody contributed" into an empty strip
 * rather than a crash.
 */
export const CLARITY_CONTROL_CENTER_TAB_BADGES_TOKEN = new InjectionToken<readonly ClarityControlCenterTabBadge[]>(
	'CLARITY_CONTROL_CENTER_TAB_BADGES',
);
